module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-03.aefb8395.jpg";